import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import constant from '../store/constant.js'

Vue.use(VueRouter)

const router = new VueRouter({routes: routes.data})

const IGNORE_BEFORE_ROUTE_GUARD_NAME = [
  'FacingTypeCardExchangeSelect'
]

router.beforeEach((to, from, next) => {
  if (window.localStorage.getItem('keep_limit') && parseInt(window.localStorage.getItem('keep_limit')) !== 0) {
    var date = new Date()
    var now = date.getTime()
    if (now > parseInt(window.localStorage.getItem('keep_limit'))) {
      window.localStorage.clear()
      window.sessionStorage.clear()
      if (!IGNORE_BEFORE_ROUTE_GUARD_NAME.includes(to.name)) {
        router.push('/login')
      }
    } else {
      var keepLimit = date.getTime() + constant.keepLimit
      window.localStorage.setItem('keep_limit', keepLimit)
    }
  }
  if (!to.matched.some(record => record.meta.noAuth) && !window.localStorage.getItem('access_token')) {
    next({path: '/login', query: {redirect: to.fullPath}})
  } else {
    next()
  }
  window.scrollTo(0, 0)
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js